import React from 'react'
// libs
import styled from 'styled-components'
// components
import { IconButton } from 'components/UI'
// static
import ArchiveIconOrigin from 'src/icons/archive.svg'
// utils
import { size } from 'polished'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'

const ArchiveIcon = styled(ArchiveIconOrigin)`
  && {
    ${size('24px')};
  }
`

const ShowArchivedFormsButton: React.FC = () => {
  const { showArchivedForms, toggleShowArchivedForms } = React.useContext(RiskAPIContext)

  return (
    <IconButton
      onClick={toggleShowArchivedForms}
      isActive={showArchivedForms}
      description={showArchivedForms ? 'Show Active Forms' : 'Show Archived Forms'}>
      <ArchiveIcon />
    </IconButton>
  )
}

export default ShowArchivedFormsButton
